import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackAndForthWarningComponent } from './back-and-forth-warning.component';
import { SharedModule } from '../../../../shared/shared.module';
import { MaterialModule } from '../../../../shared/material.module';



@NgModule({
  declarations: [
    BackAndForthWarningComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule
  ]
})
export class BackAndForthWarningModule { }
